export default {



  // Months
  jan: "كانون الثاني",
  feb: "شباط",
  mar: "آذار",
  apr: "نيسان",
  may: "مايو",
  jun: "حزيران",
  jul: "تموز",
  aug: "آب",
  sep: "أيلول",
  oct: "تِشْرِين الْأَوَّل",
  nov: "تشرين الثاني",
  dec: "كانون الأول",


  

  // Request Payment
  requestPaymentDetails: "بيانات الدفع",
  selected: "Selected AR",

  // PaymentGateWay-CyberSource
  accessKey: "مفتاح الوصول",
  profileId: "ملف البطاقة الشخصية",
  locale: "مكان",
  csUrl: "Cyber Source URL",
  secretKey: "المفتاح السري",
  csReviewUrl: "مراجعة URL",
  csResultUrl: "نتيجة URL",
  merchantId: "معرف التاجر",
  merchantName: "اسم التاجر",


  // Others
  purchase: "شراء",
  ar: "عربى",
  en: "الإنجليزية",
  KD: "KD",
  is: "هو",
  search: "بحث",
  ellipses: "...",
  OK: "حسنا",
  cancel: "إلغاء",
  save: "حفظ",
  title: "عنوان",
  clear: "واضح",
  prev: "سابق",
  next: "التالى",
  confirm: "تؤكد",
  qmark: "?",
  digits: "الأرقام.",
  copy: "نسخ",
  choose: "أختر",
  file: "ملف",
  confirmLogout: "هل أنت متأكد أنك تريد تسجيل الخروج?",
  copyright: "حقوق النشر",
  hintResponseURL: "https://payme.fcc-kuwait.com/knet/response",
  hintErrorURL: "https://payme.fcc-kuwait.com/knet/error",

  // Errors
  inActiveUser: "أنت لست مستخدم نشط! يرجى الاتصال بمسؤول النظام",
  pleaseEnterValidAmount: "الرجاء إدخال مبلغ صالح",
  dataIsNotAvailable: "البيانات غير متوفرة",
  internalError: "عذرا ، لقد حدث خطأ.",
  sessionExpired: "انتهت صلاحية جلسة العمل الخاصة بك. الرجاء تسجيل الدخول.",
  networkError: "غير قادر على الإتصال بالسيرفر. حاول مرة اخرى.",
  notAuthorized: "غير مصرح لك بأداء العمل. يرجى الاتصال المسؤول.",
  invalidUsernameOrPassword: "خطأ في اسم المستخدم أو كلمة مرور.",
  tenantAlreadyExist: "المستأجر موجود بالفعل.",
  customerAlreadyExist: "العميل موجود بالفعل.",
  pleaseFilledRequiredFields: "يرجى ملء الحقول المطلوبة.",
  pleaseFillAllRequiredFields: "يرجى تعبئة جميع الحقول المطلوبة.",
  unMatchedNewAndConfirmPassword:
    "كلمة المرور الجديدة لا تتطابق مع تأكيد كلمة المرور.",
  unMatchedPasswordAndConfirmPassword:
    "كلمة المرور غير متطابقة مع تأكيد كلمة المرور.",
  somethingWentWrong: "هناك خطأ ما.",
  pleaseSelectCustomer: "يرجى اختيار العملاء.",
  notAvailable: "N/A",
  maximumRetryAttemptReached:
    "تم الوصول إلى أقصى محاولات. يرجى تقديم طلب جديد.",
  tokenExpiredMakeNewRequest: "انتهت صلاحية الرمز. يرجى تقديم طلب جديد.",
  tokenAlreadyProcessed: "تمت معالجة المعاملة بالفعل.",
  tokenNotFound: "الرمز غير موجود.",
  knetInitFailed: "فشلت التهيئة الأولى.",
  invalidMobileNumber: "رقم النقال غير صالح.",
  invalidMobileNumberLength: "يجب أن يكون رقم النقال",
  invalidCurrentPassword: "كلمة مرور غير صحيحة.",
  weakPassword:
    "يجب أن تكون كلمة المرور أبجدية رقمية ويجب أن تحتوي على الأقل على حرف واحد خاص وطول 8-12",
  matchedNewAndCurrentPassword:
    "كلمة المرور الجديدة هي نفس كلمة المرور الحالية.",
  noNetworkConnection: "لا يوجد اتصال بالشبكة.",
  invalidErrorUrl: "عنوان URL خطأ غير صحيح.",
  invalidResponseUrl: "عنوان URL للاستجابة غير صالح.",
  minMobileNumberLength: "يجب أن يكون رقم النقال",
  adminUserAlreadyExist: "المستخدم مع البريد الإلكتروني المعطى موجود بالفعل.",
  pleaseCreateRolesFirst: "Please add Roles first AR",
  roleAlreadyExists: "الدور مع الاسم المحدد موجود بالفعل.",
  roleNotFound: "الدور غير موجود",
  roleIsAssignedToUser:
    "لا يمكن إلغاء تنشيط الدور لأنه تم تعيينه لمستخدم واحد على الأقل.",
  invalidConfiguration: "الترتيب غير صالح",
  groupAlreadyExists: "المجموعة ذات الاسم المحدد موجودة بالفعل.",
  paymentGatewayNotConfigured:
    "لا توجد بوابة دفع مكونة. لا يمكنك بدء طلب الدفع.",
  // payment screens
  paymentText: "كيف تريد أن تدفع؟",
  reference: "مرجع",
  track: "المسار",
  knetTrack: "مسار KNET",
  paymentTrack: "مسار الدفع",
  id: "رقم بطاقة الهوية",
  pay: "ادفع الآن",
  paymentError: "خطأ الدفع",
  paymentFailed: "عملية الدفع فشلت",
  merchantConfirmSmt: "يطلب الدفع منك.",
  paymentConfirmSmt: "يرجى تأكيد التفاصيل أدناه لمتابعة الدفع.",
  KnetRefID: "المرجع كنيت",
  KnetTransID: "كنيت ترانس",
  KnetPaymentID: "الدفع الصافي",
  MReferenceID: "مرجع التاجر",
  FPayTrackID: "المسار",
  MigsTransactionNo: "معاملة بطاقة الائتمان",
  MigsReceiptNo: "إيصال بطاقة الائتمان",
  clickHere: "انقر هنا.",
  clickHereText: "إذا لم تتم إعادة توجيهك في بضع ثوانٍ ،",
  thank_you: "شكرا جزيلا!",
  thank_you_desc: "دفعتك مكتملة بنجاح",
  SelectMethod: "اختار طريقة الدفع",
  OrderSummary: "ملخص الطلب",
  KNET: "كي نت",
  KNETSubTitle: "إعادة التوجيه إلى صفحة الدفع Knet.",
  CreditCard: "بطاقة الائتمان",
  CreditCardSubTitle: "نحن نقبل فيزا وماستر كارد.",
  TotalPrice: "السعر الكلي",
  oops: "آسف !!",
  payment_fail_lbl: "فشل الدفع الخاص بك",
  payment_fail_desc: "حاول مرة اخرى",
  error_msg: "عذرًا ، حدث خطأ.",
  unknown_payment: "دفع غير معروف",
};



// WEBPACK FOOTER //
// ./src/resources/i18n/ar.js